import { PlainDateTimeISO } from '@ardoq/api-types';
import { dateFromTimestamp } from '@ardoq/date-time';

export const MAX_DATE = dateFromTimestamp(8640000000000000);
export const MIN_DATE = dateFromTimestamp(-8640000000000000);
export const MAX_DATE_ISO_STRING: PlainDateTimeISO = MAX_DATE.toISOString();
export const MIN_DATE_ISO_STRING: PlainDateTimeISO = MIN_DATE.toISOString();
